import "./ZoneWiseAttendanceReport.css";
import React, { useState, useEffect, useRef } from "react";
import { format, isSameDay } from "date-fns";
import DatePicker from "react-datepicker";
import { sameDatesAttendanceForItmReport, } from "../../../../services/dashboard";
import { zoneWiseAttendaceSameDates, zoneWiseAttendaceDistrictClick, zoneWiseEmployeeLevelByDate, zoneWiseAttendaceDifferentDAte } from "../../../../services/dashboardReports";
import { handleSortByTime } from "../../../../utils/sortingOrderByTime";
import { convertToIST } from "../../../../utils/validations";

const ZoneWiseAttendanceReport = () => {
    const today = new Date();

    /* ---------- Core state ---------- */
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [sameDayAttendance, setSameDayAttendance] = useState(null);   // original payload
    const [differenceDayAttendace, setDifferenceDayAttendance] = useState();
    const zoneName = localStorage.getItem("zoneName");
    const zoneId = localStorage.getItem("zoneId");
    const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');
    const [districtId, setDistrictId] = useState(null);
    const [districtTableClick, setDistrictTableClick] = useState();
    const [userData, setUSerData] = useState([]);
    /* ---------- Filter state ---------- */
    const [displayMode, setDisplayMode] = useState("all"); // all | present | absent | notInLocation
    const [filteredRecords, setFilteredRecords] = useState([]); // what the table renders
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState(null);
    const [filterTitle, setFilterTitle] = useState("");
    const [districtName, setDistrictName] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [employeeTable, setEmployeeTable] = useState([]);
    const [employeeLevelVisible, setEmployeeLevelVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState("asc");
    /* ---------- Load original attendance (same day / range) ---------- */
    useEffect(() => {
        const fetchAttendance = async () => {
            try {
                const same = isSameDay(fromDate, toDate);
                if (same) {
                    const data = await zoneWiseAttendaceSameDates(zoneId, fromDate, toDate);
                    setSameDayAttendance(data);
                    setFilteredRecords(data || []);
                    setDisplayMode("all");
                    setFilterTitle("");
                    setEmployeeLevelVisible("");
                }
                else {
                    const data = await zoneWiseAttendaceDifferentDAte(zoneId, fromDate, toDate);
                    setDifferenceDayAttendance(data);
                    setSameDayAttendance(null);
                    setFilterTitle("");
                    setEmployeeLevelVisible("");
                    setDistrictId("");
                    setSelectedDate("");
                }
            } catch (e) {
                console.error(e);
            } finally {
                setFilterLoading(false);
            }
        };
        fetchAttendance();
    }, [fromDate, toDate, zoneId]);


    const handleRowClick = async (rowDate) => {
        setSelectedDate(rowDate);
        setFilterLoading(true);

        try {
            const data = await zoneWiseAttendaceSameDates(zoneId, rowDate, rowDate);
            // setEmployeeTable(data);
            setFilteredRecords(data || []);
            // setEmployeeLevelVisible(true);
            setEmployeeLevelVisible("");
        } catch (err) {
            console.error(err);
        } finally {
            setFilterLoading(false);
        }
    };

    const handleDistrictClick = async (id, name) => {
        setDistrictId(id);
        setDistrictName(name);
        setFilterLoading(true);

        try {
            const data = await sameDatesAttendanceForItmReport(id, selectedDate || fromDate, selectedDate || fromDate);
            setEmployeeTable(data);

            setSameDayAttendance(null);
            setFilterTitle(`District - ${name}`);
            setEmployeeLevelVisible(true);
        } catch (err) {
            console.error(err);
            setFilterError("Failed to load district data");
        } finally {
            setFilterLoading(false);
        }
    };


    const handleBackToDistrict = () => {
        setEmployeeLevelVisible(false);
    };

    const handleBackToZone = () => {
        setDistrictId(null);
        setDistrictTableClick([]);
        setEmployeeLevelVisible(false);
    };


    /* ---------- Table rows ---------- */
    const renderRows = () => {
        if (filterLoading) return <tr><td colSpan={9} className="text-center">Loading…</td></tr>;
        if (filterError) return <tr><td colSpan={9} className="text-center text-danger">{filterError}</td></tr>;
        if (!filteredRecords.length) return <tr><td colSpan={9} className="text-center">No data</td></tr>;

        return filteredRecords.map((emp, i) => (
            <tr key={i} onClick={() => handleDistrictClick(emp.districtId, emp.districtName)}>
                <td>{i + 1}</td>
                <td className="text-start" >{emp.districtName ?? "-"}</td>
                <td>{emp.totalEmployeeCount}</td>
                <td>{emp.presentCount ?? "-"}</td>
                <td>{emp.leaveCount}</td>
                <td>{emp.absentCount}</td>
            </tr>
        ));
    };

    return (
        <div className="zone-dashboard-page-repo">
            <div className="zone-new-dashboard-dash-repo">
                <div className="zone-current-month-date-dash-repo">
                    <h2>Zone Attendance Report</h2>
                </div>


                <div className="zone-dates-repo">
                    <div className="zone-container-part-repo"><div className="zone-districtzone text-center">Zone Attendance - <span className="text-nowrap">{zoneName}</span></div></div>
                    <div className="zone-container-part-repo">
                        <div className={`zone-floating-label-container-1-repo ${fromDate ? "filled" : ""}`}>
                            <DatePicker selected={fromDate} onChange={setFromDate} dateFormat="dd-MM-yyyy" maxDate={today} placeholderText=" " />
                            <label>From Date</label>
                        </div>
                    </div>
                    <div className="zone-container-part-repo">
                        <div className={`zone-floating-label-container-1-repo ${toDate ? "filled" : ""}`}>
                            <DatePicker selected={toDate} onChange={setToDate} dateFormat="dd-MM-yyyy" minDate={fromDate} maxDate={today} placeholderText=" " />
                            <label>To Date</label>
                        </div>
                    </div>
                </div>

                {!isSameDay(fromDate, toDate) && (
                    /* your existing range table – omitted for brevity */
                    <div className="border rounded-2 mt-5 thick-border">
                        <table className="mx-auto my-3">
                            <thead className="itm-table-head-dash-repo">
                                <tr >
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Total No. of Employees</th>
                                    <th>No. of Employees Present</th>
                                    <th>No. of Employees on Leave</th>
                                    <th>No. of Employees Absent</th>
                                    {/* <th>No. of Remarks</th> */}
                                </tr>
                            </thead>
                            <tbody className="table-body-dash-repo " style={{ cursor: "pointer" }}>
                                {differenceDayAttendace?.length > 0 ? (
                                    differenceDayAttendace.map((record, index) => (
                                        <tr key={index} onClick={() => handleRowClick(record.date)}>
                                            <td>{index + 1}</td>
                                            <td>{format(record.date, 'dd-MM-yyyy') || "-"}</td>
                                            <td>{record.totalEmployeesCount}</td>
                                            <td>{record.presentCount || "-"}</td>
                                            <td>{record.leaveCount}</td>
                                            <td>{record.absentCount}</td>
                                            {/* <td>{record.remarksCount || "-"}</td> */}

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                                            {userData?.dailyRecords ? 'No attendance data available.' : 'Loading attendance data…'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                )}
                {isSameDay(fromDate, toDate) && (
                    <>

                        <div className="zone-table-for-emp-repo ">
                            <table className="zone-table-dash-repo ">
                                <thead className="zone-table-head-dash-repo">
                                    <tr>
                                        <th>S.No</th>
                                        <th>District </th>
                                        <th>Total No. of Employees</th>
                                        <th>No.of Employee Present </th>
                                        <th>No.of Employee on Leave </th>
                                        <th>No.of Employee Absent </th>

                                    </tr>
                                </thead>
                                <tbody className="table-body-dash-repo">{renderRows()}</tbody>
                            </table>
                        </div>
                    </>
                )}

                {selectedDate && !isSameDay(fromDate, toDate) && (
                    <>
                        <div className="mt-5">
                            <h3>District data for the date - {format(selectedDate, 'dd-MM-yyyy')}</h3>
                            <div className="zone-table-for-emp-repo ">

                                <table className="zone-table-dash-repo ">
                                    <thead className="zone-table-head-dash-repo">
                                        <tr>
                                            <th>S.No</th>
                                            <th>District </th>
                                            <th>Total No. of Employees</th>
                                            <th>No.of Employee Present </th>
                                            <th>No.of Employee on Leave </th>
                                            <th>No.of Employee Absent </th>

                                        </tr>
                                    </thead>
                                    <tbody className="table-body-dash-repo">{renderRows()}</tbody>
                                </table>
                            </div>
                        </div>

                    </>
                )}

                {employeeLevelVisible && (
                    <>
                        <button className="btn btn-secondary mt-5" onClick={handleBackToDistrict}>Back</button>

                        <h3>Employee Attendance for {districtName} - {format(selectedDate || fromDate, "dd-MM-yyyy")}</h3>
                        <div className="border rounded-2 thick-border">
                            <table className="zone-table-dash-repo-emp-repo mt-3">
                                <thead className="zone-table-head-dash-repo">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Employee Name</th>
                                        <th>Designation</th>
                                        <th>Working Location</th>

                                        <th>Mobile Number</th>
                                        <th> Attendance Status</th>
                                        <th
                                            onClick={() =>
                                                handleSortByTime(sortOrder, setSortOrder, employeeTable, setEmployeeTable)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            Attendance Time {sortOrder === "asc" ? "▲" : "▼"}
                                        </th>

                                        <th>Location Status</th>
                                        <th>Remarks</th>
                                        <th>Attendance Photo</th>
                                    </tr>
                                </thead>

                                <tbody className="table-body-dash-repo-zone ">
                                    {employeeTable?.records?.length > 0 ? (
                                        employeeTable?.records.map((emp, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className="text-start">{emp.employeeName ?? "-"}</td>
                                                <td>{emp.designation ?? "-"}</td>
                                                <td>{emp.isWorkLocation === true ? (emp.workLocationName?.trim() || "-") : (emp.godownName?.trim() || "-")}</td>
                                                <td>{emp.contactNumber ?? "-"}</td>
                                                <td>{emp.attendanceStatus === "Not Marked" ? "Absent" : emp.attendanceStatus}</td>
                                                <td>{emp.attendanceTime ? convertToIST(emp.attendanceDate, emp.attendanceTime) : "-"}</td>
                                                <td>{emp.attendanceStatus === "Present" && (!emp.remarks || emp.remarks === "" || emp.remarks === "Inside the godown") ? "In the location" : emp.remarks && emp.attendanceStatus === "Present" ? "Not in the location" : "-"}</td>
                                                <td>{emp.remarks === "null" || emp.remarks === "" || emp.remarks === null || emp.remarks === "Inside the godown" ? "-" : emp.remarks}</td>
                                                <td>
                                                    {/* {getFileName(record.selfieUrl)} */}
                                                    <span className="employee-selfie">{emp?.selfieUrl ? (
                                                        <a
                                                            href={emp.selfieUrl.startsWith("http")
                                                                ? emp.selfieUrl
                                                                : `${process.env.REACT_APP_FILE_BASE_URL}/${emp.selfieUrl}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}</span></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">No Employee Data</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </>
                )}




            </div>
        </div>
    );
};

export default ZoneWiseAttendanceReport;